import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M3,7.252h6.15L7.439,5.6a.75.75,0,0,1,1.04-1.08l3.04,2.94a.747.747,0,0,1,.23.54.764.764,0,0,1-.23.54l-3.04,2.93a.769.769,0,0,1-.52.21.7.7,0,0,1-.54-.23.746.746,0,0,1,.02-1.06l1.7-1.64H3a.75.75,0,0,1,0-1.5Zm8.43-6H4.569a3.325,3.325,0,0,0-3.32,3.32.75.75,0,0,0,1.5,0,1.814,1.814,0,0,1,1.82-1.82h6.86a1.82,1.82,0,0,1,1.82,1.82v6.86a1.827,1.827,0,0,1-1.82,1.82H4.569a1.82,1.82,0,0,1-1.82-1.82.75.75,0,0,0-1.5,0,3.325,3.325,0,0,0,3.32,3.32h6.86a3.325,3.325,0,0,0,3.32-3.32V4.572A3.325,3.325,0,0,0,11.429,1.252Z';
const draw24px =
  'M15.71,12.07a.72.72,0,0,1-.06.29.85.85,0,0,1-.17.25l-3.05,2.93a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l1.71-1.64H6a.75.75,0,1,1,0-1.5H13.1L11.39,9.67a.75.75,0,0,1,0-1.06.75.75,0,0,1,1.06,0l3.05,2.94a.74.74,0,0,1,.17.25A.68.68,0,0,1,15.71,12.07Zm4,3.94V8A3.75,3.75,0,0,0,16,4.26H8A3.75,3.75,0,0,0,4.24,8a.75.75,0,0,0,1.5,0A2.25,2.25,0,0,1,8,5.76h8A2.25,2.25,0,0,1,18.24,8v8A2.25,2.25,0,0,1,16,18.26H8A2.25,2.25,0,0,1,5.74,16a.75.75,0,0,0-1.5,0A3.75,3.75,0,0,0,8,19.76h8A3.75,3.75,0,0,0,19.74,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowGenericRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowGenericRight')) as IconWithRender;

ArrowGenericRightIcon.displayName = 'ArrowGenericRightIcon';
ArrowGenericRightIcon.propTypes = Icon.propTypes;
ArrowGenericRightIcon.renderIcon = (props) => (
  <ArrowGenericRightIcon {...props} />
);
export default ArrowGenericRightIcon;
